// extracted by mini-css-extract-plugin
export default {"card":"SedeHomeDetalle_card__7ljwE","h1":"SedeHomeDetalle_h1__VtIdl","button":"SedeHomeDetalle_button__LwRf5","text":"SedeHomeDetalle_text__uooNE"};